import { useFillsGraphConfigurationSelector } from 'widgets/fillsGraph/store/configuration/selectors';
import { useDispatchUpdateFillsGraphConfiguration } from 'widgets/fillsGraph/store/configuration/dispatcher';
import {
    CollapsableCompanionChartType,
    toggleConfigProperty,
} from 'widgets/fillsGraph/store/configuration/FillsGraphConfiguration';
import ShowHideToggle from 'utils/components/ShowHideToggle/ShowHideToggle';
import React from 'react';

import './CollapseCompanionChartToggleButton.scss';
import { useWidgetContext } from 'widgets/WidgetContext';

export interface CollapseCompanionChartButtonProps {
    section: CollapsableCompanionChartType;
}

export function CollapseCompanionChartToggleButton(
    props: CollapseCompanionChartButtonProps
) {
    const { section } = props;

    const { width } = useWidgetContext();

    const config = useFillsGraphConfigurationSelector();
    const updateConfig = useDispatchUpdateFillsGraphConfiguration();

    const collapsed = !!config[section].collapsed;

    const onToggleCollapsed = () =>
        updateConfig(toggleConfigProperty(config, section, 'collapsed'));

    const style = { marginLeft: width - 56 };

    return (
        <ShowHideToggle
            className="CollapseCompanionChartToggleButton"
            style={style}
            status={collapsed ? 'show' : 'hide'}
            onToggle={onToggleCollapsed}
        />
    );
}
